import { createReducer } from 'redux-starter-kit';
import { putLegalDocument, putLegalDocuments, deleteLegalDocument } from './legalDocumentActions';


/**
 * A selector for a specific legal document version.
 * @param {object} state The redux state of the application.
 */
export const selectLegalDocument = (state, documentType, versionNumber) => {
  const legalDocument = state.via.domain.legalDocuments[documentType][versionNumber];
  if (!legalDocument) return undefined;

  return legalDocument;
};

/**
 * A selector for and array of all legalDocuments for a given type.
 * @param {object} state
 * @param {string} documentType the type of document (e.g privacy-policy)
 */
export const selectLegalDocuments = (state, documentType) => {
  const legalDocuments = state.via.domain.legalDocuments[documentType];
  if (!legalDocuments) return undefined;

  return Object.values(legalDocuments);
};

const initialLegalDocumentsState = {
  // privacy-policy: {
  //   1: { legal-document-object },
  //   2: { legal-document-object },
  // },
  // terms-of-use: {
  //   1: { legal-document-object },
  //   2: { legal-document-object },
  // },
};

/**
 * A reducer for managing the Application Config in the domain.
 */
const legalDocumentReducer = createReducer(initialLegalDocumentsState, {
  // Inserts/Updates the legal document
  [putLegalDocument]: (state, action) => {
    const legalDocument = action.payload;
    return {
      ...state,
      [legalDocument.documentType]: {
        ...state[legalDocument.documentType],
        [legalDocument.versionNumber]: legalDocument,
      },
    };
  },

  // Replaces all the legalDocuments in the state.
  [putLegalDocuments]: (state, action) => {
    const legalDocuments = action.payload;

    return legalDocuments.reduce((newState, legalDocument) => {
      newState[legalDocument.documentType] = {// eslint-disable-line no-param-reassign
        ...newState[legalDocument.documentType],
        [legalDocument.versionNumber]: legalDocument,
      };
      return newState;
    }, { });
  },

  [deleteLegalDocument]: (state, action) => {
    const { documentType, versionNumber } = action.payload;
    return {
      ...state,
      [documentType]: {
        ...state[documentType],
        [versionNumber]: null,
      },
    };
  },
});

export default legalDocumentReducer;
